export default {
  header: 'Precisamos de verificar o seu número de telemóvel',
  remember_device: {
    label: 'Lembrar este dispositivo durante {{days}} dias',
  },
  buttons: {
    confirm: 'Confirmar',
  },
  toasts: {
    invalid_code: 'Código inválido. Tente novamente.',
  },
};
